import { Button, Tooltip } from 'antd';
import { BulbOutlined } from '@ant-design/icons';
import { useAiAgent } from '@/contexts/AiAgentContext';

export function IntelligenceToolbarButton() {
  const { toggleIntelligenceSidebar, pageContext } = useAiAgent();
  const hasCtx = !!(pageContext.module || pageContext.docType || pageContext.docId);
  return (
    <Tooltip title={hasCtx ? 'Intelligence sidebar (Ctrl+Shift+I)' : 'Open a document for contextual intelligence'}>
      <Button
        type="text"
        icon={<BulbOutlined style={{ color: '#145a54', fontSize: 18 }} />}
        onClick={toggleIntelligenceSidebar}
        aria-label="Open intelligence sidebar"
      />
    </Tooltip>
  );
}
